import { addDays } from 'date-fns';
import { Priority } from '../types';

export const computeDateFromPriority = (
  priority: Priority,
  date = new Date(),
) => {
  return addDays(date, priority.delay);
};
